export {
  FeatureElectricCars as default,
  getStaticProps,
} from '@cinch-nx/feature-electric-cars'
